import { parseDomain } from '../../utils';
import { dynamicLoadApiClient, dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isPremiumDomainQuery = async _ref => {
  let httpClient = _ref.httpClient,
    request = _ref.request;
  const _await$dynamicLoadApi = await dynamicLoadApiClient(),
    DomainsApiClient = _await$dynamicLoadApi.DomainsApiClient;
  const _await$dynamicLoadApi2 = await dynamicLoadApiQueries(httpClient),
    checkDomainAvailability = _await$dynamicLoadApi2.checkDomainAvailability;
  const requestedDomain = parseDomain(request.domain).asciiDomain.toLowerCase();
  let isPremiumDomain = null;
  DomainsApiClient.findInCache('suggestDomains', {
    pred: _ref2 => {
      var _response$suggestions;
      let response = _ref2.response;
      const match = response == null || (_response$suggestions = response.suggestions) == null ? void 0 : _response$suggestions.find(_ref3 => {
        let domain = _ref3.domain;
        return (domain == null ? void 0 : domain.toLowerCase()) === requestedDomain;
      });
      if (match) {
        isPremiumDomain = !!match.premium;
      }
      return false;
    }
  });
  if (isPremiumDomain !== null) {
    return {
      isPremiumDomain
    };
  }
  DomainsApiClient.findInCache('domainAvailability', {
    pred: _ref4 => {
      var _response$domainName, _response$suggestions2;
      let response = _ref4.response;
      const matchAvailability = (response == null || (_response$domainName = response.domainName) == null ? void 0 : _response$domainName.toLowerCase()) === requestedDomain;
      const matchSuggestions = response == null || (_response$suggestions2 = response.suggestions) == null ? void 0 : _response$suggestions2.find(_ref5 => {
        let domain = _ref5.domain;
        return (domain == null ? void 0 : domain.toLowerCase()) === requestedDomain;
      });
      if (matchAvailability) {
        isPremiumDomain = !!(response != null && response.premium);
      }
      if (matchSuggestions) {
        isPremiumDomain = !!(matchSuggestions != null && matchSuggestions.premium);
      }
      return false;
    }
  });
  if (isPremiumDomain !== null) {
    return {
      isPremiumDomain
    };
  }
  const _await$checkDomainAva = await checkDomainAvailability({
      domain: requestedDomain
    }),
    availability = _await$checkDomainAva.availability;
  return {
    isPremiumDomain: !!(availability != null && availability.premium)
  };
};
//# sourceMappingURL=isPremiumDomain.js.map